module.exports = __webpack_public_path__ + "img/pic.96f2b057.jpg";